import { memo, useCallback, useMemo } from 'react';
import { ImageElement } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Element/ImageElement';
import PlayerMenuTooltip from '@/App/remotion/components/PlayerMenus/PlayerMenuTooltip';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import {
  IMAGE_ELEMENT_BORDER_RADIUS_DEFAULT,
  IMAGE_ELEMENT_BORDER_RADIUS_FULL
} from '@/Pages/Clip/ClipPlayer/ClipAssets/constants';
import { updateElementStylesHandler } from '@/Pages/Clip/ClipPlayer/ClipAssets/handlers';
import Icon from '@/components/atoms/Icon';

function ImageElementBorderRadiusToggle({ selectedElement }: { selectedElement: ImageElement }) {
  const { clipId, clipData } = useClipsContext();

  const currentBorderRadius = useMemo(
    () => selectedElement?.style?.borderRadius || IMAGE_ELEMENT_BORDER_RADIUS_DEFAULT,
    [selectedElement?.style?.borderRadius]
  );

  const isRounded = useMemo(() => {
    return currentBorderRadius === IMAGE_ELEMENT_BORDER_RADIUS_FULL;
  }, [currentBorderRadius]);

  const toggleBorderRadius = useCallback(() => {
    if (!selectedElement?.id) {
      return;
    }
    const newBorderRadius = isRounded ? IMAGE_ELEMENT_BORDER_RADIUS_DEFAULT : IMAGE_ELEMENT_BORDER_RADIUS_FULL;
    updateElementStylesHandler(clipData, clipId, selectedElement.id, { borderRadius: newBorderRadius });
  }, [clipId, isRounded, selectedElement?.id, clipData]);

  return (
    <button
      onClick={toggleBorderRadius}
      data-testid="image-element-border-radius-toggle"
      className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
    >
      <Icon name={isRounded ? 'IconBorderCornerPill' : 'IconBorderCornerSquare'} size={20} />
      <PlayerMenuTooltip content="Corner radius" />
    </button>
  );
}

export default memo(ImageElementBorderRadiusToggle);
